import React, { useState } from 'react';
import Crown from '../../../../../assets/images/dashboard-profile-progress-crown.png';
import Modal from '../../shared/Modal';
import { DashboardArticles } from '../DashboardArticles';
import { DashboardOganizations } from '../DashboardOrganizations';

const DashboardTab = ({
	headers,
	current_user,
	profile_progress,
	profile_progress_percent_complete,
	profile_progress_count_complete,
	recommended_articles,
	mask_content,
	recommended_organizations,
	lists,
	createListAndFollow,
	addOrRemoveArticle,
	articleData,
	setArticleData,
	organizationData,
	setOrganizationData,
	modalContentOrganizations,
}) => {
	const [showProgress, setShowProgress] = useState(false);
	/**
	 * Method to show the modify-list modal for articles, responsible for following/unfollowing/or creating a new list.
	 */
	const modalContentArticles = () => {
		if (!articleData.article) {
			return <div />;
		}

		return (
			<div className="modal-section">
				<h3>
					Add item to:
					<i
						id="new-list-close-button"
						className="fas fa-times float-right"
						onClick={() => setArticleData('')}
					/>
				</h3>
				{lists.map((followsList, index) => {
					let articleIds = followsList.articles.map(
						(articleData) => articleData.article.id
					);
					return (
						<h5
							className="name-holder"
							onClick={() =>
								addOrRemoveArticle(articleData, followsList)
							}
							key={followsList.id}
						>
							{articleIds.includes(articleData.article.id) ? (
								<i className="fa fa-minus-circle" />
							) : (
								<i className="fa fa-plus-circle" />
							)}
							<span className="list-name">
								{followsList.name}
							</span>
						</h5>
					);
				})}
				<h6>Add to new list</h6>
				<input
					id="new-list-input-box"
					className="new-list-input-box"
					type="text"
					placeholder="Insert list name here..."
				/>
				<div className="primary-button float-right">
					<input
						className="primary-button"
						type="submit"
						value="Save"
						onClick={() => createListAndFollow(articleData, true)}
					/>
				</div>
			</div>
		);
	};

	return (
		<>
			<div
				className="hero-container"
				onMouseLeave={() => setShowProgress(false)}
			>
				<div className="row">
					<div className="columns small-12 medium-3">
						<h1 className="dashboard-header">
							{'Hey ' + current_user.first_name + '!'}
						</h1>
						Welcome back to Sponsor Circle
					</div>
				</div>
				<div className="row">
					<div className="columns small-12 medium-6 profile-progress-container">
						<h3>Optimize your profile</h3>
						<p>
							Optimize your profile to find the best partners.
							Click the bar and choose an item that needs to be
							completed.
						</p>
						<div className="profile-progress-box-container">
							{profile_progress.map((pp, index) => {
								return (
									<div
										className={
											'profile-progress-box' +
											(index <
											profile_progress_count_complete
												? ' box-' +
												  (index + 1).toString()
												: '')
										}
										onMouseEnter={() =>
											setShowProgress(true)
										}
										key={index}
									/>
								);
							})}
							<img src={Crown} />
							<div
								className={
									'profile-progress-tooltip-container' +
									(showProgress ? '' : ' hide')
								}
							>
								{profile_progress.map((pp, index) => {
									return (
										<div
											className="profile-progress-tooltip-item"
											key={index}
										>
											{pp.complete == true ? (
												<>
													<i className="fas fa-check"></i>
													{pp.title}
												</>
											) : (
												<>
													<i className="fas fa-check invisible"></i>
													<a href={pp.link}>
														{pp.title}
													</a>
												</>
											)}
										</div>
									);
								})}
							</div>
						</div>
						<div className="percent-container font-large">
							{profile_progress_percent_complete + '% completed'}
						</div>
					</div>
				</div>
			</div>
			<DashboardArticles
				headers={headers}
				recommended_articles={recommended_articles}
			/>
			<DashboardOganizations
				headers={headers}
				mask_content={mask_content}
				recommended_organizations={recommended_organizations}
			/>
			<Modal
				Content={modalContentArticles}
				modalState={articleData}
				turnOffModal={() => setArticleData('')}
				style={{ width: '15rem', padding: '1rem' }}
			/>
			<Modal
				Content={modalContentOrganizations}
				modalState={organizationData}
				turnOffModal={() => setOrganizationData('')}
				style={{ width: '15rem', padding: '1rem' }}
			/>
		</>
	);
};

export default DashboardTab;
